import { NotificationToast, NotificationToastAction, Severity } from '@sib/ui';
import { toast } from 'sonner';

type ToastOptions = {
  id?: string | number;
  description?: string;
  isExtension?: boolean;
  duration?: number;
  action?: NotificationToastAction;
};

export const createToast =
  (variant: Severity) => (message: string, opts?: ToastOptions) =>
    toast.custom(
      () => (
        <NotificationToast
          variant={variant}
          title={message}
          isExtension={opts?.isExtension}
          description={opts?.description || ''}
          onClose={() => {
            toast.dismiss(opts?.id);
          }}
          action={opts?.action}
        />
      ),
      {
        id: opts?.id,
        duration: opts?.duration,
      }
    );
